import { FormattedMessage } from 'react-intl';

import { UserOutlined, FileOutlined, BarsOutlined, AppstoreAddOutlined, CalendarOutlined } from '@ant-design/icons';

import { NavItemType } from 'types/menu';

const icons = {
  FileOutlined,
  UserOutlined,
  BarsOutlined,
  AppstoreAddOutlined,
  CalendarOutlined
};

const applications: NavItemType = {
  id: 'group-applications',
  title: <FormattedMessage id="applications" />,
  icon: icons.AppstoreAddOutlined,
  type: 'group',
  children: [
    {
      id: 'patient-list',
      title: <FormattedMessage id="patient-list" />,
      type: 'item',
      icon: icons.UserOutlined,
      url: '/apps/patients/list'
    },
    {
      id: 'visit-list',
      title: <FormattedMessage id="visit-list" />,
      type: 'item',
      icon: icons.CalendarOutlined,
      url: '/apps/visit/list'
    },
    {
      id: 'recent-assessment-list',
      title: <FormattedMessage id="assessments" />,
      type: 'item',
      icon: icons.BarsOutlined,
      url: '/apps/assessment/list'
    },
    {
      id: 'templates-list',
      title: <FormattedMessage id="templates" />,
      type: 'item',
      icon: icons.FileOutlined,
      url: '/apps/assessment/templates'
    }
  ]
};

export default applications;
